import { LanguagePreference } from '../../interface';

const ENGLISH_PREFIX = '/en';

export const getLanguageFromPath = (pathname: string): LanguagePreference =>
  pathname === ENGLISH_PREFIX || pathname.startsWith(`${ENGLISH_PREFIX}/`)
    ? LanguagePreference.ENGLISH
    : LanguagePreference.LATVIAN;

// Returns the path without the language prefix, e.g. "/en/pricing" -> "/pricing"
export const stripLanguagePrefix = (pathname: string): string => {
  if (getLanguageFromPath(pathname) === LanguagePreference.LATVIAN) {
    return pathname;
  }
  return pathname.slice(ENGLISH_PREFIX.length) || '/';
};

// Builds the URL of a path in the given language. Latvian stays unprefixed.
export const localizePath = (
  path: string,
  language: LanguagePreference
): string => {
  const basePath = stripLanguagePrefix(path);
  if (language === LanguagePreference.LATVIAN) {
    return basePath;
  }
  return basePath === '/' ? ENGLISH_PREFIX : `${ENGLISH_PREFIX}${basePath}`;
};
